import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { CLIENT, TASK, TASKALL, WORKTASK } from "../../services/actions";
import React from "react";
import { Button, Container, Box, Grid, Tab, Tabs, Pagination, Avatar, Typography, Card, Stack, Divider, Chip } from "@mui/material";
import InfoCard from "../extra/InfoCard";
import { BsCheckSquare, BsDashSquare, BsFilePlusFill } from "react-icons/bs";
import RDialog from "../extra/RDialog";
import Form from './Form';
import ActionBar from "../extra/ActionBar";
import SearchBar from "../extra/SearchBar";
// import InfoCard2 from "../extra/InfoCard2";
import { isBase64Image, seedData } from "../../libs/Libs";
import XTable from "../extra/XTableAnother";
import MoreInfo from "../extra/MoreInfo";
import { BsCopy } from "react-icons/bs";
import MyCard from "../extra/Card"
import NoData from "../extra/NoData";
import TaskChatModal from "./TaskChatModal";
import BlockReasonModal from "./BlockReasonModal";

export default function View() {
  let dispatch = useDispatch()
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const backUrl = params.get("back");
  const task_id = params.get("task");
  const work_name = params.get("work_name");
  const work_id = params.get("work");
  const hasSpecificParam = Boolean(work_id || task_id || work_name);

  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});
  const [view, setView] = React.useState(1);
  const [chatModalOpen, setChatModalOpen] = React.useState(false);
  const [blockModalOpen, setBlockModalOpen] = React.useState(false);
  const [selectedTask, setSelectedTask] = React.useState(null);
  const navigate = useNavigate();
  let taskState = useSelector((state) => state?.taskState);
  let taskallState = useSelector((state) => state?.taskallState);
  const [companies, setCompanies] = React.useState([]);
  let user = useSelector((state) => state?.loginState?.auth);
  const [page, setPage] = React.useState(0); // current page  
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const getCurrentFinancialYear = () => {
    return new Date().getFullYear().toString();
  };

  const getFinancialYears = () => {
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let y = 2022; y <= currentYear + 1; y++) {
      years.push(y.toString());
    }
    return years;
  };

  const [financialYear, setFinancialYear] = React.useState(hasSpecificParam ? "" : getCurrentFinancialYear());
  const [month, setMonth] = React.useState("");
  const [employeeName, setEmployeeName] = React.useState("");

  React.useEffect(() => {
    if (hasSpecificParam) {
      setFinancialYear("");
    }
  }, [location.search]);

  const fetchTasks = (id = 0) => {
    let baseFilter = {};
    if (work_id) {
      baseFilter.work_id = parseInt(work_id);
    }
    if (task_id) {
      baseFilter.id = parseInt(task_id);
    }
    if (work_name && !work_id) {
      baseFilter["work__work_name__icontains"] = work_name;
    }
    if (financialYear) {
      baseFilter.work__financial_year = financialYear;
    }
    if (employeeName) {
      baseFilter["assignment__employee__first_name__icontains"] = employeeName;
    }
    if (month) {
      baseFilter["created_at__month"] = parseInt(month);
    }

    const filterStr = JSON.stringify(baseFilter);
    const url = `work/task/${page}/?filter_by=${filterStr}`;
    dispatch({ type: `${TASKALL}_GET`, payload: url });
  };

  const updateTask = (payload) => {
    dispatch({
      type: `${WORKTASK}_PATCH`, payload, callback: () => {
        fetchTasks(0);
      }
    });
  };

  const handleStatusChange = (task, newStatus) => {
    if (newStatus === "blocked") {
      setSelectedTask(task);
      setBlockModalOpen(true);
    } else {
      updateTask({ id: task.work_task_id || task.id, status: newStatus });
    }
  };

  const handleBlockSubmit = (reason) => {
    if (selectedTask) {
      updateTask({
        id: selectedTask.work_task_id || selectedTask.id,
        status: "blocked",
        remarks: reason
      });
    }
    setBlockModalOpen(false);
    setSelectedTask(null);
  };

  React.useEffect(() => {
    try {
      fetchTasks(0);
    } catch (err) {
    }
  }, [page, financialYear, month, employeeName, location.search]);


  React.useEffect(() => {
    if (taskState?.success) {
      setOpen(!taskState?.success)
      fetchTasks(0);
    }
  }, [taskState?.data])

  React.useEffect(() => {
    if (task_id && taskallState?.data?.results?.length > 0) {
      const targetTask = taskallState.data.results.find(
        (t) => String(t.id) === String(task_id) || String(t.work_task_id) === String(task_id)
      );
      if (targetTask) {
        setSelectedTask(targetTask);
        setChatModalOpen(true);
      }
    }
  }, [task_id, taskallState?.data?.results]);

  // Handle filter search
  const handleSearch = (key, value) => {
    const query = `work/task/0/?filter_by={"work_id":${work_id},"${key}":"${value}"}`;
    dispatch({ type: `${TASKALL}_GET`, payload: query });
  };
  const tableHeadings = ["ID", "Task Name", "Assigned Employee", "Status", "Checklists", "Last Updated"];
  const tableRows = taskallState?.data?.results?.map((task) => ({
    id: task.id,
    task_name: task.task_name || "-",
    assigned_employee: task.assigned_to_name ? `👤 ${task.assigned_to_name}` : "Not Assigned",
    status: task.status || "pending",
    checklists: `${(task.checkedlist || []).filter(c => c.status).length} / ${(task.checkedlist || []).length} completed`,
    last_updated: task.last_updated ? new Date(task.last_updated).toLocaleDateString() : "-"
  }));

  const handleDelete = (id) => {
    dispatch({ type: `${TASK}_DELETE`, payload: id });
  };

  const transformData = (data) => {
    return {
      id: data.id || 0,
      task_name: data.task_name || "",
      description: data.description || "",
      checklist: Object.keys(data)
        .filter(key => key?.startsWith("checklist_"))
        .map(key => ({
          label: data[key],
          status: false
        }))
    };
  };

  let colorMap = {
    pending: { label: "Pending", color: "#92c3e3ff" },
    in_progress: { label: "In Progress", color: "#a1a1e6ff" },
    approved: { label: "Approved", color: "#179a17ff" },
    rejected: { label: "Rejected", color: "#e96d6dff" },
    completed: { label: "Completed", color: "#0da62eff" },
    blocked: { label: "Blocked", color: "#bb0b0bff" },
    review: { label: "Under Review", color: "#57f6deff" },
  }

  const canApproveOrComplete = Boolean(
    user?.is_superuser || 
    ["Work Admin", "Work Manager", "Super Admin", "Review", "Reviewer", "Approver"].includes(user?.main_role) ||
    (Array.isArray(user?.groups) && user.groups.some(g => ["Work Admin", "Work Manager", "Super Admin", "Review", "Reviewer", "Approver"].includes(typeof g === 'string' ? g : g?.name))) ||
    (Array.isArray(user?.permissions) && (user.permissions.includes("can_approve_task") || user.permissions.includes("work.can_approve_task")))
  );

  const availableStatuses = canApproveOrComplete
    ? ["pending", "in_progress", "review", "completed", "approved", "rejected", "blocked"]
    : ["pending", "in_progress", "review", "rejected", "blocked"];

  const keyValue = availableStatuses.map(k => <option key={k} value={k}>{colorMap[k]?.label || k}</option>)

  const handleChecklistClick = (id, label, checklist) => {
    const updatedChecklist = checklist.map((item) => {
      if (item.label === label) {
        return {
          ...item,
          status: !item.status, // or toggle: !item.status
        };
      }
      return item;
    });

    const selected = updatedChecklist
      .filter(item => item.status)
      .map(item => item.label);

    updateTask({
      id: id,
      checkedlist: selected,
    });
  };
  return (
    <>

      {open ? <div>
        <Form
          tasks={(taskallState?.data?.results || [])}
          defaultValues={defV}
          onSubmit={(payload) => {
            payload = transformData(payload)
            if (!isBase64Image(payload.image)) {
              delete payload["image"]
            }

            let action = payload.id ? `${WORKTASK}_PATCH` : `${WORKTASK}_POST`
            dispatch({ type: action, payload })
          }}
          back={() => { setOpen(false) }}
        /></div>
        : <Container maxWidth="false" className="py-3">
          <Box className="card-bg" sx={{ my: 2, py: 0.2, px: 2, borderRadius: 1 }}>
            <ActionBar
              showGrid={[2, 5]}
              onBtnClick={(type, col) => {
                if (type == "previous") {
                  navigate(backUrl || "/works/")
                }
                if (type === "grid") {
                  setView(1);
                }
                if (type === "tabular") {
                  setView(2);
                }
              }}
              hasPermission={user.permissions.includes('authentic.add_user')}
              label={work_name ? [work_name, 'Tasks'] : ['All Works', 'Tasks']}
              setOpen={(s) => {
                if (user.main_role == "Company") {
                  setCompanies(user?.companies)
                } else {
                  // dispatch({ type: `${COMPANY}_GET`, payload: 0 })
                }
                setDefV({});
                setOpen(true);

              }}
              // btnLabel="ADD TASK"
              btnPrevLabel="Back"
            />
          </Box>
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'stretch', md: 'center' }, 
              gap: 1.5, 
              flexWrap: { xs: 'wrap', md: 'nowrap' }, 
              mb: 3,
              width: '100%'
            }}
          >
            <Box sx={{ width: { xs: '100%', md: '135px' }, flexShrink: 0 }}>
              <select
                value={financialYear}
                onChange={(e) => setFinancialYear(e.target.value)}
                style={{
                  height: '40px',
                  width: '100%',
                  padding: '0 12px',
                  borderRadius: '8px',
                  border: '1px solid #cbd5e1',
                  backgroundColor: '#ffffff',
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#1e293b',
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                <option value="">All Years</option>
                {getFinancialYears().map(y => <option key={y} value={y}>{y}</option>)}
              </select>
            </Box>

            <Box sx={{ width: { xs: '100%', md: '135px' }, flexShrink: 0 }}>
              <select
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                style={{
                  height: '40px',
                  width: '100%',
                  padding: '0 12px',
                  borderRadius: '8px',
                  border: '1px solid #cbd5e1',
                  backgroundColor: '#ffffff',
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#1e293b',
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                <option value="">All Months</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
            </Box>

            <Box sx={{ flexGrow: 1, width: { xs: '100%', md: 'auto' } }}>
              <SearchBar 
                bylist={[
                  { key: "task_name__istartswith", label: 'Task Name' },
                  { key: "status__istartswith", label: 'Status' },
                  { key: "due_date__istartswith", label: 'Due Date' },
                  { key: "assignment__employee__first_name__icontains", label: 'Employee Name' }
                ]} 
                handleSearch={handleSearch} 
                sx={{ mb: 0 }}
              />
            </Box>
          </Box>
          {view === 1 && (
            <>
              {taskallState?.loading ? (
                <NoData loading={true} loadingTitle="Loading Tasks..." loadingMessage="Please wait while we retrieve tasks for this work." />
              ) : !taskallState?.data?.results || taskallState?.data?.results.length === 0 ? (
                <NoData title="No Tasks Found" message="There are no tasks available for the selected filters." />
              ) : (
                <>
                  <Grid container spacing={1}>
                    {taskallState?.data?.results?.map((task, idx) => {
                      return <Grid alignItems="stretch" size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>

                        <MyCard
                          head={task?.assigned_to ? (
                            (!canApproveOrComplete && (task.status === "completed" || task.status === "approved")) ? (
                              <Chip
                                size="small"
                                label={colorMap[task.status]?.label || task.status}
                                sx={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  background: colorMap[task.status]?.color || "#e2e8f0",
                                  color: "#1e293b",
                                  height: "24px"
                                }}
                              />
                            ) : (
                              <select
                                onChange={(e) => handleStatusChange(task, e.target.value)}
                                value={task.status}
                                style={{ 
                                  fontSize: 13, 
                                  background: colorMap[task.status]?.color || '#eee', 
                                  paddingBottom: 2, 
                                  paddingTop: 2, 
                                  paddingLeft: 8, 
                                  paddingRight: 8, 
                                  borderRadius: '4px',
                                  border: '1px solid rgba(0,0,0,0.15)',
                                  maxWidth: 130, 
                                  height: 'auto',
                                  cursor: 'pointer',
                                  fontWeight: 500
                                }}
                              >{keyValue}</select>
                            )
                          ) : <Typography>Not Assigned Task</Typography>}
                          title={task.task_name}
                          // subtitle={task?.assigned_to_name ? `👤 Assigned: ${task.assigned_to_name}` : (task.client_creation_date || "Not Assigned")}
                          hideButtons={[0, 0, 0]}
                          onAction={(action) => {
                            if ("more-info" === action) {
                              navigate("/more-info/", {
                                state: {
                                  data: task,
                                  title: "Service Task",
                                  prevNav: { url: '/services-tasks/', state: { state: { "work": work_name } } }
                                }
                              })
                            } else if ("edit" === action) {
                              console.log("tasks", task)
                              task.checklist = task.checklist?.map((c, idx) => task[`checklist_${(idx + 1)}`] = c.label)
                              setDefV(task)
                              setOpen(true)
                            } else if ("delete" === action) {
                              handleDelete(task?.id)
                            }

                          }}
                        >
                          <Stack spacing={1.5} sx={{ mt: 1 }}>
                            {task?.assigned_to_name ? (
                              <Box display="flex" alignItems="center" gap={1} sx={{ bgcolor: '#f0fdf4', p: 1, borderRadius: 1.5, border: '1px solid #bbf7d0' }}>
                                <Typography fontSize={12} fontWeight={600} color="#166534">
                                  👤 Assigned to: {task.assigned_to_name}
                                </Typography>
                              </Box>
                            ) : (
                              <Box display="flex" alignItems="center" gap={1} sx={{ bgcolor: '#fef2f2', p: 1, borderRadius: 1.5, border: '1px solid #fecaca' }}>
                                <Typography fontSize={12} fontWeight={600} color="#991b1b">
                                  ⚠️ Not Assigned Task
                                </Typography>
                              </Box>
                            )}

                            {task.status === "rejected" && (
                              <Box sx={{ p: 1, bgcolor: '#fef2f2', borderRadius: 1.5, border: '1px solid #f87171' }}>
                                <Typography fontSize={11} fontWeight={700} color="#b91c1c" display="flex" alignItems="center" gap={0.5}>
                                  ❌ Rejection Feedback:
                                </Typography>
                                <Typography fontSize={12} color="#991b1b" sx={{ mt: 0.3, whiteSpace: "pre-wrap", fontWeight: 500 }}>
                                  {task.remarks || "Task was rejected by Admin/Reviewer. Please revise and resubmit for review."}
                                </Typography>
                              </Box>
                            )}

                            {task.status === "blocked" && task.remarks && (
                              <Box sx={{ p: 1, bgcolor: '#fffbeb', borderRadius: 1.5, border: '1px solid #fde68a' }}>
                                <Typography fontSize={11} fontWeight={700} color="#b45309">
                                  🚫 Blocked Reason:
                                </Typography>
                                <Typography fontSize={12} color="#92400e" sx={{ mt: 0.2, whiteSpace: "pre-wrap" }}>
                                  {task.remarks}
                                </Typography>
                              </Box>
                            )}

                            {task?.continuity && (
                              <Box display="flex" justifyContent="center" alignItems="center" gap={1} sx={{ bgcolor: '#eff6ff', p: 1, borderRadius: 1, border: '1px dashed #bfdbfe' }}>
                                <Typography fontSize={14} color="#60a5fa" title={`Connected to ${task?.continuity}`}>🔗 Continuity</Typography>
                                <Typography color="#3b82f6" fontSize={12} fontWeight={600}>{task?.continuity}</Typography>
                              </Box>
                            )}

                            <Box sx={{ p: 1.5, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #f1f5f9' }}>
                              <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={700} mb={1}>
                                Checklists
                              </Typography>
                              <Stack spacing={0.8}>
                                {(task?.checkedlist || []).map((i) => (
                                  <Box
                                    key={i.label}
                                    onClick={() => {
                                      if (!task.work_task_id) return;
                                      handleChecklistClick(task?.work_task_id, i.label, task?.checkedlist)
                                    }
                                    }
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      p: 1,
                                      borderRadius: 1,
                                      background: i.status ? '#f0fdf4' : '#ffffff',
                                      border: '1px solid',
                                      borderColor: i.status ? '#bbf7d0' : '#e2e8f0',
                                      cursor: 'pointer',
                                      transition: 'all 0.2s',
                                      '&:hover': { background: i.status ? '#dcfce7' : '#f8fafc' }
                                    }}
                                  >
                                    <Typography fontSize={12} fontWeight={500} color={i.status ? '#166534' : '#334155'}>
                                      {i.label}
                                    </Typography>
                                    {task?.assigned_to && (
                                      <Box color={i.status ? '#10b981' : '#ef4444'} display="flex" alignItems="center">
                                        {i.status ? <BsCheckSquare size={14} /> : <BsDashSquare size={14} />}
                                      </Box>
                                    )}
                                  </Box>
                                ))}
                                {(!task?.checkedlist || task.checkedlist.length === 0) && (
                                  <Typography fontSize={11} color="textSecondary" fontStyle="italic">No checklists</Typography>
                                )}
                              </Stack>
                            </Box>
                          </Stack>

                          <Box mt={1.5}>
                            <Button
                              variant="outlined"
                              size="small"
                              fullWidth
                              onClick={() => {
                                setSelectedTask(task);
                                setChatModalOpen(true);
                              }}
                              sx={{
                                textTransform: 'none',
                                fontSize: 12,
                                fontWeight: 600,
                                borderRadius: '6px',
                                borderColor: '#cbd5e1',
                                color: '#334155',
                                bgcolor: '#f8fafc',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 0.8,
                                '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' }
                              }}
                            >
                              💬 Discussion {task.chats_count ? `(${task.chats_count})` : ''}
                            </Button>
                          </Box>

                          <Box mt={1.5}>
                            <Typography fontSize={11} color="textSecondary" sx={{ mb: 1, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>Documents</Typography>
                            <Stack direction="row" spacing={0.8} flexWrap="wrap" useFlexGap>
                              {user.permissions.includes("work.can_view_document") && ["Working File"].map((d) => (
                                <Chip
                                  key={d}
                                  label={d}
                                  size="small"
                                  onClick={() => {
                                    const param = `client=${task.repo_uuid}&object_id=${task.id}&category=${encodeURIComponent(d)}&work=${encodeURIComponent(task.work_name || "")}&service=${encodeURIComponent(task.service_name || "")}&client_name=${encodeURIComponent(task.client_name || "")}&back=/works/`
                                    navigate(`/repository/documents/0?${param}`)
                                  }}
                                  sx={{
                                    fontSize: 11,
                                    fontWeight: 600,
                                    height: 24,
                                    cursor: 'pointer',
                                    background: '#eff6ff',
                                    color: '#2563eb',
                                    border: '1px solid #bfdbfe',
                                    borderRadius: '6px',
                                    transition: 'all 0.2s',
                                    '&:hover': { background: '#dbeafe', borderColor: '#93c5fd', transform: 'translateY(-1px)' }
                                  }}
                                />
                              ))}
                            </Stack>
                          </Box>

                          {task.description && (
                            <Box mt={1.5}>
                              <Typography color="#64748b" fontSize={12} lineHeight={1.6} sx={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                {task.description}
                              </Typography>
                            </Box>
                          )}
                          {/* {task.financial_year}/ {task.client_uuid} */}
                        </MyCard>
                      </Grid>
                    })}
                  </Grid>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Pagination
                      count={Math.ceil(taskallState?.data?.count / pageSize)}
                      page={page}
                      onChange={(e, value) => setPage(value)}
                      color="primary"
                    />
                  </Box>
                </>
              )}
            </>
          )
          }
          {
            view === 2 && (
              <XTable
                head={tableHeadings}
                rows={tableRows}
                onEdit={(row) => {
                  // Find the original project data from the full results
                  const originalData = taskallState?.data?.results.find(
                    (project) => project.id === row.id
                  );

                  // Set the form's default values and open the form
                  if (originalData) {
                    setDefV(originalData);
                    setOpen(true);
                  }
                }}
                onDelete={handleDelete}
              />
            )
          }
          {
            view === 4 && <MoreInfo
              data={{
                ...defV,
                active: defV.active ? "Yes" : "No",
                verify: defV.verify ? "Yes" : "No",
              }}

              skip={['country', 'description', 'error_email', 'no_users', 'owner', 'image']}
              group={['', 'project_name', 'created_at',]}
              icons={{ project_image: <BsCopy /> }}
              css={{ project_image: { color: '#1976d2' } }}
              onClose={() => { setView(1) }} />
          }

          <TaskChatModal
            open={chatModalOpen}
            onClose={() => {
              setChatModalOpen(false);
              setSelectedTask(null);
              fetchTasks(0);
            }}
            task={selectedTask}
          />

          <BlockReasonModal
            open={blockModalOpen}
            onClose={() => {
              setBlockModalOpen(false);
              setSelectedTask(null);
            }}
            onSubmit={handleBlockSubmit}
            task={selectedTask}
          />

        </Container >}

    </>
  )
}